import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Title } from '@angular/platform-browser';

@Injectable()
export class AppServiceService {

  private window: any;

  public cursorX:any = '50%';
  public cursorY:any = '50%';
  public menu:any = '';
  public widthPanelLeft:any = 0;

  //post colection full image
  public fullImageCollection:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 

  //element collection
  public element:any = {
      'height': '380px',
      'width': '400px',
      'x': '30%',
      'y': '30%',
  };
  //element post blog/press
  public elementPost:any = {
    'height': '200px',
    'width': '200px',
    'x': '80%',
    'y': '80%',
  };

    //screen size
  public screen:any = {
    'width'  : '1920px',
    'height' : '1080px'
  };
  public screenSubject:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 

  //element designer
  public indentationDesignerImage:number = 0;

  /**
   * property left penal
   */
  //title left panel
  public title:BehaviorSubject<string> = new BehaviorSubject<string>('');
  //position menu top
  public positionMenuTop:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //white logo left panel
  public logoWhite: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //left panel transparent
  public transparent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //show arrow in leftPanel
  public arrow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //show left title (h1) in leftPanel
  public titleLeftPanel:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //external button in left penal
  public externalButton:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //animate left panel (white style)
  public showLeftPanel:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  /**
   * property menu app
   */
  //black color menu text an element
  public blackStyle: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true); 
  //state menu
  public normalMenu:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  //menu active
  public activeMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //menu state
  public menuState: BehaviorSubject<string> = new BehaviorSubject<string>('');
  //sub menu state mobile
  public submenuState: BehaviorSubject<string> = new BehaviorSubject<string>('hide');

  /**
   * property stan home animate
  */
  //black color menu text an element
  public stateSlider: BehaviorSubject<string> = new BehaviorSubject<string>(''); 

  // public elementCollection: Subject<any> = new Subject<any>();


  constructor(private titleService: Title) {
    this.title.subscribe(data => {
      if(data != ''){
        this.titleService.setTitle(data);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app-service.service.ts